var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleMap } from '@capacitor/google-maps';
import { useRef, useLayoutEffect, useCallback, memo, useState, useEffect, } from 'react';
function useGoogleMap(ref) {
    var _this = this;
    var _a = useState(-33.9249), latitude = _a[0], setLatitude = _a[1];
    var _b = useState(18.4241), longitude = _b[0], setLongitude = _b[1];
    var _c = useState(), addressComponents = _c[0], setAddressComponents = _c[1];
    var mapRef = useRef(null);
    var markerIdRef = useRef(null);
    var getAddressFromCoords = useCallback(function (lat, lng) { return __awaiter(_this, void 0, void 0, function () {
        var response, data, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4, fetch("https://maps.googleapis.com/maps/api/geocode/json?latlng=".concat(lat, ",").concat(lng, "&key=").concat(process.env.REACT_APP_MAP_API_KEY))];
                case 1:
                    response = _b.sent();
                    return [4, response.json()];
                case 2:
                    data = _b.sent();
                    if ((_a = data.results) === null || _a === void 0 ? void 0 : _a.length) {
                        setAddressComponents(data.results[0].address_components);
                    }
                    return [3, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error('Geocode error:', error_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, []);
    var updateMarker = useCallback(function (lat, lng) { return __awaiter(_this, void 0, void 0, function () {
        var _a, newMarkerId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!mapRef.current)
                        return [2];
                    if (!markerIdRef.current) return [3, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, mapRef.current.removeMarker(markerIdRef.current)];
                case 2:
                    _b.sent();
                    return [3, 4];
                case 3:
                    _a = _b.sent();
                    return [3, 4];
                case 4: return [4, mapRef.current.addMarker({
                        coordinate: { lat: lat, lng: lng },
                        draggable: true,
                    })];
                case 5:
                    newMarkerId = _b.sent();
                    markerIdRef.current = newMarkerId;
                    return [4, mapRef.current.setOnMarkerDragEndListener(function (event) {
                            if ((event === null || event === void 0 ? void 0 : event.latitude) != null && (event === null || event === void 0 ? void 0 : event.longitude) != null) {
                                var newLat = event.latitude;
                                var newLng = event.longitude;
                                setLatitude(newLat);
                                setLongitude(newLng);
                                getAddressFromCoords(newLat, newLng);
                            }
                        })];
                case 6:
                    _b.sent();
                    return [2];
            }
        });
    }); }, [getAddressFromCoords]);
    var initMaps = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var map;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ref.current || mapRef.current)
                        return [2];
                    return [4, GoogleMap.create({
                            id: 'google-map',
                            element: ref.current,
                            apiKey: process.env.REACT_APP_MAP_API_KEY || '',
                            config: {
                                center: { lat: latitude, lng: longitude },
                                zoom: 15,
                                disableDefaultUI: true,
                            },
                        })];
                case 1:
                    map = _a.sent();
                    mapRef.current = map;
                    return [4, updateMarker(latitude, longitude)];
                case 2:
                    _a.sent();
                    return [4, getAddressFromCoords(latitude, longitude)];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }); }, [latitude, longitude, ref, updateMarker, getAddressFromCoords]);
    useLayoutEffect(function () {
        navigator.geolocation.getCurrentPosition(function (_a) {
            var coords = _a.coords;
            setLatitude(coords.latitude);
            setLongitude(coords.longitude);
        }, function () { return console.log('Geolocation failed - using Cape Town default'); }, { enableHighAccuracy: true });
    }, []);
    useLayoutEffect(function () {
        initMaps();
    }, [initMaps]);
    return { addressComponents: addressComponents, latitude: latitude, longitude: longitude };
}
function CustomGoogleMapComponent(props) {
    var mapRef = useRef(null);
    var _a = useGoogleMap(mapRef), addressComponents = _a.addressComponents, latitude = _a.latitude, longitude = _a.longitude;
    useEffect(function () {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, {
            addressComponents: addressComponents,
            latitude: latitude,
            longitude: longitude,
        });
    }, [addressComponents, latitude, longitude, props.onChange]);
    return (_jsx("div", __assign({ className: "component-wrapper" }, { children: _jsx("capacitor-google-map", { ref: mapRef, style: {
                width: '100%',
                height: props.height || window.screen.height / 2,
            } }) })));
}
export var CustomGoogleMap = memo(CustomGoogleMapComponent);
//# sourceMappingURL=google-map.js.map